import { selectIsLoggedOut } from '@tokenized/sdk-js-private';
import { useTokenizedApiStateSelector } from '../../internal/redux';

/**
 * **`React hook`** Current “no session” status.
 *
 * @returns `true` when there’s no valid user session, and also no
 *   log-in process happening.
 *
 * @category Logging in and Security
 */
export function useIsLoggedOut() {
  return useTokenizedApiStateSelector(selectIsLoggedOut);
}
